import { render, staticRenderFns } from "./UserComplaints.vue?vue&type=template&id=a16b188a&scoped=true"
import script from "./UserComplaints.vue?vue&type=script&lang=js"
export * from "./UserComplaints.vue?vue&type=script&lang=js"
import style0 from "./UserComplaints.vue?vue&type=style&index=0&id=a16b188a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b188a",
  null
  
)

export default component.exports